import { map } from "rxjs";
import { GenericListField } from "@app/shared/models/GenericList/GenericListField";
import { ScopedTranslation } from "@app/shared/i18n/translation-scope";

const catalogKeyPrefix = "dashboard.";

/**
 * DashboardWidgetMapping marks its translatable values with a "dashboard." prefix, which tells
 * them apart from data values (e.g. dropdown names from the API). Returns the key relative to
 * the dashboard scope, for `| t` or `t()`.
 */
export function catalogKey(value: string): string {
    return value?.startsWith(catalogKeyPrefix) ? value.slice(catalogKeyPrefix.length) : value;
}

/**
 * DashboardWidgetMapping's prettyName/description/dropdown Name values are "dashboard.widgetCatalog.*"
 * keys (the shared generic-field-editor has no translate pipe of its own). Resolves them in place.
 * `translation` is the dashboard scope; await its ready() first.
 */
export function translateWidgetCatalogField(translation: ScopedTranslation, field: GenericListField) {
    if (field.prettyName?.startsWith(catalogKeyPrefix)) {
        field.prettyName = translation.t(catalogKey(field.prettyName));
    }
    if (field.description?.startsWith(catalogKeyPrefix)) {
        field.description = translation.t(catalogKey(field.description));
    }

    const translateNames = (items: { Name?: string }[]) => {
        items?.forEach((item) => {
            if (item?.Name?.startsWith(catalogKeyPrefix)) {
                item.Name = translation.t(catalogKey(item.Name));
            }
        });
        return items;
    };

    if (field.getDataMethod) {
        const original = field.getDataMethod.bind(field);
        field.getDataMethod = () => original().pipe(map(translateNames));
    }

    if (field.getDataMethodByRow) {
        const original = field.getDataMethodByRow.bind(field);
        field.getDataMethodByRow = (row, ds) => original(row, ds).pipe(map(translateNames));
    }
}
